import store from "../../store";
import { API_URL } from "../../../config";

export default {
  namespaced: true,
  actions: {
    async getUniverso({}, payload) {
      const response = await fetch(`${API_URL}/call/oportunidades/universo`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: store.state.token,
        },
        body: JSON.stringify(payload),
      });

      return response.json();
    },

    async getEmbudo({}, payload) {
      const response = await fetch(`${API_URL}/call/oportunidades/buscar`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: store.state.token,
        },
        body: JSON.stringify(payload),
      });

      return response.json();
    },

    async getEmbudoPorPeriodo({}, payload) {
      const response = await fetch(`${API_URL}/call/oportunidades/buscar-periodo`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: store.state.token,
        },
        body: JSON.stringify(payload),
      });

      return response.json();
    },

    async subirOportunidades({}, payload) {
      const response = await fetch(
        `${API_URL}/call/oportunidades/archivo-oportunidades`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: store.state.token,
          },
          body: JSON.stringify(payload),
        }
      );

      return response.json();
    },

    async getAsesores() {
      const response = await fetch(`${API_URL}/call/oportunidades/asesores`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: store.state.token,
        },
      });
      return response.json();
    },

    async getCanales() {
      const response = await fetch(`${API_URL}/call/oportunidades/canales`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: store.state.token,
        },
      });
      return response.json();
    },

    async getDetalle({}, payload) {
      const response = await fetch(`${API_URL}/call/oportunidades/detalle`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: store.state.token,
        },
        body: JSON.stringify(payload),
      });

      return response.json();
    },

    async getReporte({}, payload) {
      const response = await fetch(`${API_URL}/call/oportunidades/reporte`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: store.state.token,
        },
        body: JSON.stringify(payload),
      });
      return response.json();
    },

    async getAsesoresPorPeriodo({}, payload) {
      const response = await fetch(
        `${API_URL}/call/oportunidades/asesores-periodo`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: store.state.token,
          },
          body: JSON.stringify(payload),
        }
      );

      return response.json();
    },
  },
};
